<div class="controls-container">
    <div class="home-welcome-section">
        <div class="controls-header">Welcome</div>
        <div class="controls-sub-header"><pm-link Href="https://github.com/claygifford/pm-controls">https://github.com/claygifford/pm-controls</pm-link></div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/welcome/welcome.html